var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 29.03 26.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#a7b9c5;}.cls-4{clip-path:url(#clip-path-2);}.cls-5{clip-path:url(#clip-path-3);}.cls-6{clip-path:url(#clip-path-4);}.cls-7{clip-path:url(#clip-path-5);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.17,16.23V14.5H4.8a1.29,1.29,0,0,1-1-.34,1.39,1.39,0,0,1-.32-1V9.88A2.34,2.34,0,0,0,3.28,8.7a1.28,1.28,0,0,0-.78-.58,1.33,1.33,0,0,0,.78-.59,2.34,2.34,0,0,0,.24-1.18V3.05a1.39,1.39,0,0,1,.32-1,1.29,1.29,0,0,1,1-.34h.37V0H4.3A3.05,3.05,0,0,0,2.1.72a2.79,2.79,0,0,0-.75,2.11V6.4c0,.55-.26.83-.78.83H0V9H.57c.52,0,.78.28.78.83V13.4a2.79,2.79,0,0,0,.75,2.11,3.05,3.05,0,0,0,2.2.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.76,9.55A1.4,1.4,0,0,0,7.19,8.12,1.37,1.37,0,0,0,5.76,6.68a1.4,1.4,0,0,0-1,.39,1.42,1.42,0,0,0-.41,1A1.4,1.4,0,0,0,5.76,9.55Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.49,9.55a1.38,1.38,0,0,0,1.42-1.43,1.42,1.42,0,1,0-2.84,0,1.38,1.38,0,0,0,.42,1A1.36,1.36,0,0,0,9.49,9.55Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.22,9.55a1.38,1.38,0,0,0,1.42-1.43,1.39,1.39,0,0,0-.41-1,1.5,1.5,0,0,0-2,0,1.39,1.39,0,0,0-.41,1,1.38,1.38,0,0,0,1.42,1.43Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.71,16.23a3.08,3.08,0,0,0,2.21-.72,2.79,2.79,0,0,0,.75-2.11V9.83a.87.87,0,0,1,.2-.62A.75.75,0,0,1,18.44,9H19V7.23h-.59A.75.75,0,0,1,17.87,7a.87.87,0,0,1-.2-.62V2.83A2.79,2.79,0,0,0,16.92.72,3.08,3.08,0,0,0,14.71,0h-.87V1.73h.36a1.31,1.31,0,0,1,1,.34,1.35,1.35,0,0,1,.33,1v3.3a2.34,2.34,0,0,0,.23,1.19,1.33,1.33,0,0,0,.77.58,1.28,1.28,0,0,0-.77.57,2.34,2.34,0,0,0-.23,1.19v3.3a1.35,1.35,0,0,1-.33,1,1.31,1.31,0,0,1-1,.34h-.36v1.73Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 15.17,
    height: 26.23
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 4.34,
    y: 6.68,
    width: 12.84,
    height: 12.88
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 8.07,
    y: 6.68,
    width: 12.84,
    height: 12.88
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 11.8,
    y: 6.68,
    width: 12.84,
    height: 12.88
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 13.84,
    width: 15.18,
    height: 26.23
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon1);
export default __webpack_public_path__ + "static/media/chat-icon1.bc148746e0bd063e3d79eb1d19ce3b1f.svg";
export { ForwardRef as ReactComponent };